const a = {
  baseStyle: ({ theme: e, isBorder: i, size: d }) => ({
    menuTileCard: {
      border: "none",
      display: "flex",
      flex: "none",
      width: "min-content",
      height: "auto",
      alignItems: "center",
      padding: e.menutilescroller.padding,
      _hover: {
        boxShadow: e.elevation.low,
        borderRadius: e.menutilescroller.borderRadius,
        padding: e.menutilescroller.padding,
        backgroundColor: e.background.default
      },
      _active: {
        backgroundColor: e.background.mid,
        borderRadius: e.menutilescroller.borderRadius,
        padding: e.menutilescroller.padding
      }
    },
    menuTileMedia: {
      objectFit: "none",
      padding: e.menutilescroller.padding,
      img: { objectFit: "contain" },
      justifyContent: "center",
      height: d.height,
      width: d.width,
      borderRadius: i && e.menutilescroller.borderRadius,
      borderWidth: i && e.button.borderWidth,
      borderColor: i && e.border.default,
      margin: i ? `0 auto ${e.menutilescroller.padding}` : "0 auto",
      _hover: {
        borderColor: i && e.border.hover
      }
    },
    menuTileContent: {
      height: "auto"
    }
  }),
  sizes: {
    default: ({ theme: e }) => ({
      menuTileMedia: {
        width: e.imageSize[70],
        height: e.imageSize[70]
      }
    }),
    large: ({ theme: e }) => ({
      menuTileMedia: {
        width: e.imageSize[90],
        height: e.imageSize[90]
      }
    }),
    wide: ({ theme: e }) => ({
      menuTileMedia: {
        width: e.imageSize[140],
        height: e.imageSize[70]
      }
    }),
    largeWide: ({ theme: e }) => ({
      menuTileMedia: {
        width: e.imageSize[180],
        height: e.imageSize[90]
      }
    })
  },
  defaultProps: {
    size: "default",
    isBorder: !1
  }
};
export {
  a as default
};
